<template>
    <DCard
        padding
    >
        <Form
            :jira-settings="jiraSettings"
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/JiraSettings/Form'

export default {
    name: 'JiraSettingsCreate',
    components: {
        Form
    },
    props: {
        jiraSettings: {
            type: Object,
            default () {
                return {}
            }
        },
        errors: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    methods: {
        submitData (form) {
            form.post(this.$route('settings.jira-settings.store'))
        }
    }
}
</script>
